import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useCidCatalog() {
  const navigate = useNavigate();

  const [cids, setCids] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Devolve a promise (resolvida com a lista) para quem precisa agir logo após o refetch,
  // como o cadastro rápido de CID dentro do modal de atestado.
  const fetchCids = useCallback(() => {
    setLoading(true);
    return quarkusApi
      .get('/cid-catalog', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        setCids(returnFromApi.data);
        return returnFromApi.data;
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchCids();
  }, [fetchCids]);

  return { cids, isLoading, error, refetch: fetchCids };
}
